import React, { useState } from "react";
import { Rate, Input, Button} from "antd";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import Style from './SupportScore.module.css'
import { errorToast, succToast } from "../../Toast/Toast";
import { postFeedBackApi } from "../../Api/BarestServices";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const SupportScore = ({ match }) => {
  const [score, setScore] = useState(0);
  const [feedback, setFeedback] = useState("");
    const history=useHistory()
  const handleSubmit = () => {
    if (score === 0 || feedback==="") {
      errorToast("لطفا تمامی اطلاعات پر کنید!");
      return;
    }

    const data = {
      id: match.params.id, 
      score,
      feedback,
    };

    postFeedBackApi(data, (succ, res) => {
      if (succ) {
       if(res.status===1){
        succToast("نظر شما با موفقیت ثبت شد!")
        setTimeout(() => {
            history.goBack()
        }, 500);
       }else{
        errorToast(res.message)
       }
      } else {
        console.error(res)
      }
    });
  };

  return (
    <div className={Style.PageHolder}>
      <BurgerMenuTitle title="ثبت بازخورد" />
      <section className={Style.SectionHolder}>
        <h2>نظرتو درباره ما بگو و امتیاز بده!</h2>
        <div className={Style.rateHolder}>
        <Rate onChange={(value) => setScore(value)} value={score}/>
        </div>
        <Input.TextArea
          placeholder="نظرتو بنویس"
          rows={4}
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          className={Style.textAreaHolder}
        />
        <Button
          type="primary"
          onClick={handleSubmit}
          style={{ marginTop: "20px",background:'#da0069',border:'none',width:'100%' }}
        >
          ثبت
        </Button>
      </section>
    </div>
  );
};

export default SupportScore;
